<script>
/**
 * Create a status
 */
import ProjectActionCategoryService from "@/services/ProjectActionCategoryService";
import ProjectActionService from "@/services/ProjectActionService";
import UserService from "@/services/UserService";
import Cloner from "@/libraries/Cloner";
import { mapGetters } from "vuex";
import ActionViewer from "./components/ActionViewer.vue";

export default {
    props: {
        context: {},
        projectId: {},
        projectActionCategoryId: {},
        projectMomId: {}
    },
    components: { ActionViewer },
    data() {
        return {
            editing: false,
            loading: true,
            categories: [],
            linkables: [],
            users: [],
            preview: null,
            pLoading: false,
            saving: false,
            errors: false,
            entity: {
                id: null,
                action_category_id: "",
                linked_action_id: null,
                project_id: null,
                project_mom_id: null,
                user_id: null,
                due_date: null,
                notes: null,
                status: null,
                action_type: 1,
                create_task_mode: 0
            },
            newTask: {
                user_id: null,
                due_date: null,
                notes: null,
                status: 0,
                action_type: "2"
            }
        };
    },
    computed: {
        ...mapGetters("auth", ["getMyId"]),
        actionTypes() {
            return {
                1: this.$t("project_actions.atype_status"),
                2: this.$t("project_actions.atype_task")
            };
        },
        linkedAction() {
            return this.entity.linked_action_id;
        },
        createTaskMode() {
            return this.entity.create_task_mode;
        }
    },
    watch: {
        createTaskMode(nV) {
            if (nV) {
                this.entity.linked_action_id = null;
                this.preview = null;
            } else {
                this.newTask = {
                    user_id: null,
                    due_date: null,
                    notes: null,
                    status: 0,
                    action_type: "2"
                };
            }
        },
        linkedAction: async function(nV, oV) {
            this.pLoading = true;
            if (parseInt(nV) > 0) {
                try {
                    const { data } = await ProjectActionService.GETS(nV);
                    this.preview = data.data;
                } catch (e) {
                    console.log("watch linkedfACtion e", e);
                }
            } else {
                this.preview = null;
            }
            this.pLoading = false;
        }
    },
    async created() {
        if (!this.context.empty) {
            this.editing = true;
            this.entity = {
                ...Cloner.pickClone(this.context, [
                    "id",
                    "action_category_id",
                    "project_id",
                    "user_id",
                    "due_date",
                    "linked_action_id",
                    "notes",
                    "status",
                    "action_type"
                ]),
                create_task_mode: 0
            };
        } else {
            this.entity.project_id = this.projectId;
            this.entity.user_id = this.getMyId;
            this.entity.action_category_id = this.projectActionCategoryId;
            if (this.projectMomId) {
                this.entity.project_mom_id = this.projectMomId;
            }
        }
        await this.getLinkable();
        await this.fetchCategories();
        await this.fetchUsers();
        this.loading = false;
    },
    methods: {
        async getLinkable() {
            try {
                const params = {
                    linked_action_id: this.entity.linked_action_id
                };
                if (this.projectMomId) {
                    params.project_mom_id = this.projectMomId;
                } else {
                    params.context = "datatab";
                }
                const { data } = await ProjectActionService.GET_linkable(
                    this.projectId,
                    2,
                    params
                );
                this.linkables = data.data;
            } catch (e) {
                console.log("getLinkable e", e);
            }
        },
        async saveForm() {
            try {
                const { create_task_mode, ...payload } = this.entity;
                if (create_task_mode) {
                    payload.linked_action_id = null;
                    payload.new_task = { ...this.newTask };
                    if (this.projectMomId) {
                        payload.new_task.project_mom_id = this.projectMomId;
                    }
                }
                if (this.editing) {
                    await ProjectActionService.PUT(payload);
                } else {
                    await ProjectActionService.POST(payload);
                }
                this.$emit("close-reload");
            } catch (e) {
                this.errors = e.response.data.errors;
            }
        },
        async fetchCategories() {
            try {
                const params = {};
                if (this.projectMomId) {
                    params.project_mom_id = this.projectMomId;
                } else {
                    params.context = "datatab";
                }
                const {
                    data
                } = await ProjectActionCategoryService.GET_dropdown(
                    this.projectId,
                    params
                );
                this.categories = data.data;
            } catch (e) {
                console.log("fc e", e);
            }
        },
        /**
         * Fetch users
         */
        async fetchUsers() {
            try {
                const r = await UserService.dropdown();
                this.users = r.data.data;
            } catch (e) {}
        },
        async deleteEntity() {
            this.$swal({
                icon: "warning",
                text: this.$t("project_actions.delete_are_you_sure"),
                showConfirmButton: true,
                showCancelButton: true
            }).then(async confirmed => {
                if (confirmed.isConfirmed) {
                    try {
                        this.$notify({
                            message: this.$t("project_actions.notify_deleted"),
                            timeout: 5000,
                            icon: "far fa-check",
                            type: "success"
                        });
                        await ProjectActionService.DELETE(this.entity.id);

                        this.$emit("close-reload");
                    } catch (e) {}
                }
            });
        }
    }
};
</script>

<template>
    <modal
        size="xl"
        :show="true"
        @close="$emit('close')"
        class="budget-modal"
        :loading="loading"
    >
        <template slot="header">
            <template v-if="editing"
                >{{ $t("project_actions.edit_status") }}
            </template>
            <template v-else>{{
                $t("project_actions.create_status")
            }}</template>
        </template>

        <template slot="default">
            <FormulateForm :errors="errors" @submit="saveForm" v-model="entity">
                <div class="row">
                    <FormulateErrors />

                    <div class="col-12">
                        <FormulateInput
                            name="action_category_id"
                            type="select"
                            disabled
                            :options="categories"
                            :label="$t('project_actions.category')"
                            :placeholder="
                                $t('project_actions.placeholder_category')
                            "
                            :validation-name="$t('project_actions.category')"
                            validation="required"
                        />
                    </div>
                    <div class="col-12" v-if="false">
                        <FormulateInput
                            type="select"
                            :options="actionTypes"
                            :label="$t('project_actions.entry_type')"
                            :placeholder="$t('project_actions.entry_type')"
                            name="action_type"
                        />
                    </div>
                    <div class="col-12">
                        <FormulateInput
                            type="multiselect"
                            :options="users"
                            :label="$t('project_actions.hdr_added_by')"
                            :placeholder="$t('project_actions.hdr_added_by')"
                            name="user_id"
                        />
                    </div>
                    <div v-show="entity.action_type == 2">
                        <div class="col-12">
                            <FormulateInput
                                type="date"
                                name="due_date"
                                :label="$t('project_actions.hdr_due')"
                            />
                        </div>
                        <div class="col-12">
                            <FormulateInput
                                type="fswitch"
                                name="status"
                                :label="$t('project_actions.hdr_status')"
                            />
                        </div>
                    </div>
                    <div class="col-12">
                        <FormulateInput
                            name="notes"
                            type="textarea"
                            :placeholder="$t('project_actions.hdr_description')"
                            :label="$t('project_actions.hdr_description')"
                            rows="8"
                            validation="required"
                        />

                        <FormulateInput
                            v-if="!editing"
                            type="fswitch"
                            name="create_task_mode"
                            :label="
                                $t('project_actions.create_new_task_toggle')
                            "
                        />

                        <template v-if="!entity.create_task_mode">
                            <FormulateInput
                                name="linked_action_id"
                                type="multiselect"
                                :options="linkables"
                                :label="
                                    $t('project_actions.link_status_to_a_task')
                                "
                            />
                            <div>
                                <v-loader :loading="pLoading" v-if="pLoading" />
                                <template v-else>
                                    <action-viewer :action="preview" />
                                </template>
                            </div>
                        </template>

                        <template v-else>
                            <FormulateForm v-model="newTask">
                                <div class="row">
                                    <div class="col-12">
                                        <FormulateInput
                                            type="multiselect"
                                            :options="users"
                                            name="user_id"
                                            :label="$t('project_actions.owner')"
                                            :placeholder="
                                                $t('project_actions.owner')
                                            "
                                        />
                                    </div>
                                    <div class="col-12">
                                        <FormulateInput
                                            type="date"
                                            name="due_date"
                                            :label="
                                                $t('project_actions.hdr_due')
                                            "
                                        />
                                    </div>
                                    <div class="col-12">
                                        <FormulateInput
                                            type="fswitch"
                                            name="status"
                                            :label="
                                                $t(
                                                    'project_actions.hdr_is_completed'
                                                )
                                            "
                                        />
                                    </div>
                                    <div class="col-12">
                                        <FormulateInput
                                            type="textarea"
                                            name="notes"
                                            :placeholder="
                                                $t(
                                                    'project_actions.hdr_description'
                                                )
                                            "
                                            :label="
                                                $t(
                                                    'project_actions.hdr_description'
                                                )
                                            "
                                            rows="5"
                                            validation="required"
                                        />
                                    </div>
                                </div>
                            </FormulateForm>
                        </template>
                        <div class="row mt-4">
                            <div class="col">
                                <base-button
                                    type="danger"
                                    :outline="true"
                                    @click="deleteEntity"
                                    v-if="editing"
                                    ><i class="far fa-trash"></i>
                                    {{ $t("delete") }}</base-button
                                >
                            </div>
                            <div class="col text-right">
                                <base-button
                                    type="secondary"
                                    :outline="true"
                                    @click="$emit('close')"
                                    >{{ $t("cancel") }}</base-button
                                >
                                <base-button
                                    type="primary"
                                    :loading="saving"
                                    native-type="submit"
                                    >{{ $t("save") }}</base-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </FormulateForm>
        </template>
    </modal>
</template>
